import React, { useEffect, useRef } from 'react';


const Contact = () => {
  const canvasRef = useRef(null);
     const mousePosRef = useRef(null);
     const pointsRef = useRef([]);
     const animationRef = useRef(null);
   
     const maxDist = 200;
     const colour = "#FFFFFF";
   
     useEffect(() => {
       const canvas = canvasRef.current;
       const ctx = canvas.getContext("2d");
   
       // Point constructor
       class Point {
         constructor() {
           this.x = (Math.random() * (canvas.width + maxDist)) - (maxDist / 2);
           this.y = (Math.random() * (canvas.height + maxDist)) - (maxDist / 2);
           this.vx = (Math.random() * 2) - 1;
           this.vy = (Math.random() * 2) - 1;
           this.dia = Math.random() * 3 + 1;
         }
       }
   
       // Generate points
       const generatePoints = (amount) => {
         pointsRef.current = [];
         for (let i = 0; i < amount; i++) {
           pointsRef.current.push(new Point());
         }
       };
   
       // Draw function
       const draw = (obj) => {
         ctx.beginPath();
         ctx.fillStyle = colour;
         if (obj.dia) {
           ctx.arc(obj.x, obj.y, obj.dia, 0, 2 * Math.PI);
         } else {
           ctx.arc(obj.x, obj.y, 2, 0, 2 * Math.PI);
         }
         ctx.closePath();
         ctx.fill();
       };
   
       // Update function
       const update = (obj) => {
         obj.x += obj.vx;
         obj.y += obj.vy;
         if (obj.x > canvas.width + (maxDist / 2)) {
           obj.x = -(maxDist / 2);
         } else if (obj.x < -(maxDist / 2)) {
           obj.x = canvas.width + (maxDist / 2);
         }
         if (obj.y > canvas.height + (maxDist / 2)) {
           obj.y = -(maxDist / 2);
         } else if (obj.y < -(maxDist / 2)) {
           obj.y = canvas.height + (maxDist / 2);
         }
       };
   
       // Collision detection and line drawing
       const collision = (obj, dist) => {
         let temp;
         for (let i = 0; i < pointsRef.current.length; i++) {
           if (obj !== pointsRef.current[i]) {
             temp = Math.sqrt(
               Math.pow((obj.x - pointsRef.current[i].x), 2) + 
               Math.pow((obj.y - pointsRef.current[i].y), 2)
             );
             if (temp < dist) {
               ctx.beginPath();
               ctx.moveTo(obj.x, obj.y);
               ctx.strokeStyle = `rgba(255,255,255,${0.8 * Math.pow((dist - temp) / dist, 5)})`;
               ctx.moveTo(obj.x, obj.y);
               ctx.lineTo(pointsRef.current[i].x, pointsRef.current[i].y);
               ctx.closePath();
               ctx.stroke();
             }
           }
         }
       };
   
       // Main animation loop
       const pointFun = () => {
         ctx.clearRect(0, 0, canvas.width, canvas.height);
         if (mousePosRef.current) {
           collision(mousePosRef.current, maxDist * 2);
           draw(mousePosRef.current);
         }
         for (let i = 0; i < pointsRef.current.length; i++) {
           collision(pointsRef.current[i], maxDist);
           draw(pointsRef.current[i]);
           update(pointsRef.current[i]);
         }
       };
   
       // Resize canvas
       const resizeCanvas = () => {
         canvas.width = document.documentElement.clientWidth;
         canvas.height = window.innerHeight;
         generatePoints(170);
         pointFun();
       };
   
       // Mouse move handler
       const handleMouseMove = (evt) => {
         const rect = canvas.getBoundingClientRect();
         mousePosRef.current = {
           x: evt.clientX - rect.left,
           y: evt.clientY - rect.top
         };
       };
   
       // Initialize
       resizeCanvas();
       pointFun();
   
       // Start animation
       const interval = setInterval(pointFun, 16);
       animationRef.current = interval;
   
       // Event listeners
       window.addEventListener('resize', resizeCanvas);
       canvas.addEventListener('mousemove', handleMouseMove);
   
       // Cleanup
       return () => {
         clearInterval(interval);
         window.removeEventListener('resize', resizeCanvas);
         canvas.removeEventListener('mousemove', handleMouseMove);
       };
     }, []);
   
     return (
       <div style={{ 
         overflow: 'hidden',
         width: '100%',
         maxWidth: '100vw',
            paddingTop: '130px'
       }}>
         <div style={{ 
           margin: 0, 
           padding: 0, 
           overflow: 'hidden',
           width: '100%',
           height: '60vh',
           position: 'relative'
         }}>
           <canvas
             ref={canvasRef}
             id="canvas"
             style={{
               overflow: 'hidden',
               cursor: 'none',
               position: 'absolute',
               top: 0,
               left: 0,
               width: '100%',
               height: '100%',
               background: 'linear-gradient(to bottom, #306873, #52A7B0)'
             }}
           />
           <div style={{
             position: 'absolute',
             top: '50%',
             left: '50%',
             transform: 'translate(-50%, -50%)',
             textAlign: 'center',
             zIndex: 1
           }}>
                <h2 style={{
                  color: '#ffffff',
                  fontSize: '3rem',
                  fontWeight: 'bold',
                  textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                  maxWidth: '900px',
                  margin: '0 auto',
                  textAlign: 'center'
                }}>
                  Contact Us
                </h2>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '1rem'
                }}>
                  <p style={{
                    color: '#ffffff',
                    fontSize: '1.1rem',
                    textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                    maxWidth: '650px',
                    textAlign: 'center',
                    margin: 0,
                    lineHeight: '1.6',
                    fontWeight: 400
                  }}>
                    Let's discuss how we can help your business grow with our virtual assistance solutions.
                  </p>
                  <p style={{
                    color: '#ffffff',
                    fontSize: '1.1rem',
                    textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                    maxWidth: '650px',
                    textAlign: 'center',
                    margin: '1rem 0 0 0',
                    lineHeight: '1.6',
                    fontWeight: 400
                  }}>
                    Get in touch with our team for personalized support and expert guidance.
                  </p>
                </div>
           </div>
         </div>

      {/* Contact Information Section */}
      <section className="contact-section" style={{ padding: '80px 0' }}>
        <div className="container">
          <div className="row">
            {/* Left Side - Contact Information */}
            <div className="col-lg-5 mb-5 mb-lg-0">
              <div className="contact-info pe-lg-4">
                <h2 className="section-title mb-4">Contact Us</h2>
                <p className="text-muted mb-5">
                  Ready to transform your business with <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span> <span className="workdeskva-va">VA</span></span> expert virtual assistance? 
                  Reach out to us through any of these channels, and we'll respond within 24 hours.
                </p>

                  {/* Contact Details */}
                <div className="contact-details">
                  {/* Location */}
                  <div className="contact-item d-flex align-items-center mb-4">
                    <div className="icon-box me-3" style={{
                      background: '#f8f9fa',
                      padding: '15px',
                      borderRadius: '10px'
                    }}>
                      <i className="fas fa-map-marker-alt" style={{ color: '#23a1ab', fontSize: '24px' }}></i>
                    </div>
                    <div>
                      <h5 className="mb-1">Global Office</h5>
                      <p className="mb-0 text-muted">Remote-First Company, Serving Worldwide</p>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="contact-item d-flex align-items-center mb-4">
                    <div className="icon-box me-3" style={{
                      background: '#f8f9fa',
                      padding: '15px',
                      borderRadius: '10px'
                    }}>
                      <i className="fas fa-envelope" style={{ color: '#23a1ab', fontSize: '24px' }}></i>
                    </div>
                    <div>
                      <h5 className="mb-1">Email Support</h5>
                      <p className="mb-0 text-muted">info@workdeskva.com</p>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="contact-item d-flex align-items-center mb-4">
                    <div className="icon-box me-3" style={{
                      background: '#f8f9fa',
                      padding: '15px',
                      borderRadius: '10px'
                    }}>
                      <i className="fas fa-phone-alt" style={{ color: '#23a1ab', fontSize: '24px' }}></i>
                    </div>
                    <div>
                      <h5 className="mb-1">24/7 Support</h5>
                      <p className="mb-0 text-muted">+1 (800) WORKDESK-VA</p>
                    </div>
                  </div>

                  {/* Working Hours */}
                  <div className="contact-item d-flex align-items-center">
                    <div className="icon-box me-3" style={{
                      background: '#f8f9fa',
                      padding: '15px',
                      borderRadius: '10px'
                    }}>
                      <i className="fas fa-globe" style={{ color: '#23a1ab', fontSize: '24px' }}></i>
                    </div>
                    <div>
                      <h5 className="mb-1">Global Coverage</h5>
                      <p className="mb-0 text-muted">24/7 Support Across All Time Zones</p>
                    </div>
                  </div>
                </div>               
              </div>
            </div>

            {/* Right Side - Contact Form */}
            <div className="col-lg-7">
              <div className="contact-form-wrapper" style={{
                background: 'white',
                borderRadius: '15px',
                padding: '40px',
                boxShadow: '0 0 10px rgba(0,0,0,0.1)'
              }}>
                <h3 className="mb-4">Send Us a Message</h3>
                <form className="contact-form">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Your Name*"
                        required
                        style={{ padding: '12px 15px' }}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Your Email*"
                        required
                        style={{ padding: '12px 15px' }}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Phone Number"
                        style={{ padding: '12px 15px' }}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <select className="form-select" style={{ padding: '12px 15px' }}>
                        <option selected disabled>Select Service</option>
                        <option>Virtual Assistant</option>
                        <option>Web Development</option>
                        <option>Digital Marketing</option>
                        <option>Content Writing</option>
                        <option>Other Services</option>
                      </select>
                    </div>
                    <div className="col-12 mb-3">
                      <textarea
                        className="form-control"
                        rows="5"
                        placeholder="Your Message*"
                        required
                        style={{ padding: '12px 15px' }}
                      ></textarea>
                    </div>
                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        style={{
                          padding: '12px 30px',
                          background: '#23a1ab',
                          border: 'none',
                          fontWeight: '600'
                        }}
                      >
                        Send Message
                        <i className="fas fa-arrow-right ms-2"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section" style={{ padding: '0' }}>
        <div className="container-fluid p-0">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387193.30596098663!2d-74.25987363344967!3d40.69714941680757!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2s!4v1635167158395!5m2!1sen!2s"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default Contact;
